import React from "react";
import "./Industry.css"; // Importing CSS file
import "bootstrap-icons/font/bootstrap-icons.css"; // Import Bootstrap Icons

const industries = [
  {
    icon: "bi-capsule-pill",
    title: "Pharma Industry",
    description:
      "Providing automation and monitoring solutions for pharmaceutical manufacturing to ensure accuracy, compliance, and efficiency in critical processes."
  },
  {
    icon: "bi-laptop",
    title: "IT Industry",
    description:
      "Delivering IoT, IIoT, and smart data solutions that help IT companies manage infrastructure, improve uptime, and optimize performance."
  },
  {
    icon: "bi-fuel-pump",
    title: "Gas & Oil",
    description:
      "Advanced SCADA & PLC automation for safe and efficient operations in gas and oil extraction, refining, and distribution."
  },
  {
    icon: "bi-cpu",
    title: "Electronics",
    description:
      "Supporting electronics manufacturing with precision automation, monitoring, and smart control systems for consistent quality."
  },
  {
    icon: "bi-droplet",
    title: "Water Industry",
    description:
      "Smart water management solutions for municipalities, industries, and residential sectors to optimize usage and reduce waste."
  },
  {
    icon: "bi-bank",
    title: "Government Projects",
    description:
      "Executing government water mechanical projects with reliable automation, SCADA systems, and smart metering solutions."
  }
];

const Industry = () => {
  return (
    <section id="industries" className="industries-section py-5">
      <div className="container">
        <h2 className="text-center fw-bold mb-5 text-primary">
          Industries We Serve
        </h2>
        <div className="row g-4">
          {industries.map((industry, index) => (
            <div className="col-md-6 col-lg-4" key={index}>
              <div className="industry-card h-100">
                <div className="icon-box">
                  <i className={`bi ${industry.icon}`}></i>
                </div>
                <h4>{industry.title}</h4>
                <p>{industry.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Industry;
